import { AlertBar, Icon } from './styles'

export default Object.assign(AlertBar, {
  Icon
})
